interface RuntimeConfig {
  VITE_BASE_API_PATH?: string;
  VITE_BASE_PATH?: string;
  VITE_AUTH_AUTHORITY?: string;
  VITE_AUTH_CLIENT_ID?: string;
  VITE_AUTH_REDIRECT_URI?: string;
  [key: string]: string | undefined;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

/**
 * Get environment configuration, supporting both runtime (window.__RUNTIME_CONFIG__)
 * and build-time (import.meta.env) configurations.
 * Runtime config takes precedence for production deployments.
 */
export const getEnvConfig = (): RuntimeConfig => {
  // Support both runtime (production) and build-time (development) configs
  // Pattern: window.__RUNTIME_CONFIG__ || import.meta.env
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__;
  }
  // Fallback to Vite's import.meta.env for development
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env as RuntimeConfig;
  }
  return {};
};

export const getApiBasePath = (): string | undefined => {
  return getEnvConfig().VITE_BASE_API_PATH;
};

export const getBasePath = (): string | undefined => {
  return getEnvConfig().VITE_BASE_PATH;
};

export const getAuthAuthority = (): string | undefined => {
  return getEnvConfig().VITE_AUTH_AUTHORITY;
};

export const getAuthClientId = (): string | undefined => {
  return getEnvConfig().VITE_AUTH_CLIENT_ID;
};

export const getAuthRedirectUri = (): string | undefined => {
  return getEnvConfig().VITE_AUTH_REDIRECT_URI;
};
